export const KOREAN_CARRIERS = {
    KOREA_POST: 'KOREA_POST',
    CJ_LOGISTICS: 'CJ_LOGISTICS',
    HANJIN_SHIPPING: 'HANJIN_SHIPPING',
    LOTTE_LOGISTICS: 'LOTTE_LOGISTICS',
    LOGEN_DELIVERY: 'LOGEN_DELIVERY',
    DAESIN: 'DAESIN',
    KYUNGDONG_EXPRESS: 'KYUNGDONG_EXPRESS',
    ILYANG_LOGISTICS: 'ILYANG_LOGISTICS',
    CHUNIL_EXPRESS: 'CHUNIL_EXPRESS',
    HAPDONG_EXPRESS: 'HAPDONG_EXPRESS',
    GS_POSTBOX: 'GS_POSTBOX',
    CU_POST: 'CU_POST',
    KUNYOUNG_EXPRESS: 'KUNYOUNG_EXPRESS',
    WOORI_EXPRESS: 'WOORI_EXPRESS',
    NH_LOGISTICS: 'NH_LOGISTICS',
};
export const KOREAN_CARRIER_VALUES = Object.values(KOREAN_CARRIERS);
//# sourceMappingURL=korean-carriers.js.map